import React from "react";
import SeoHead from "../../components/SeoHead";
import Header from "../../components/MainHeader";
import SubBanner from "../../components/SubBanner";
import { Global, Collection, Jobs } from "@sourceflow-uk/sourceflow-sdk";
import SimplePage from "../../components/SimplePage";
import SimpleImageWithText from "../../components/SimpleImageWithText";
import SimpleTwoColumns from "../../components/SimpleTwoColumns";
import stripTags from "../../functions/stripTags";
import SimpleTextWithText from "../../components/SimpleTextWithText";
import LatestJobs from "../../components/LatestJobs";
import TextWithCTA from "../../components/TextWithCTA";
import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import SimpleForm from "../../components/SimpleForm";

export default function Solutions({ solutions, all_jobs }) {
  return (
    <>
      <SeoHead
        // site_name={`Driving Force`}
        page_name={`Employers - ${solutions.title}`}
        // description={``}
        canonical_link={`/clients-page//${solutions.url_slug}/`}
      />
      <Header slug_url={`${solutions.url_slug}`} />

      <SubBanner
        global={global}
        pathPrefix={`employers_specialsm_page.sub_banner`}
        customClass={`mb-5 pb-5 client-banner`}
        buttonTitle={`Job Search By Client`}
        buttonLink={`/job-search-by-client`}
        customBannerColor={solutions.main_banner_hex_color_code}
        consultantPage={false}
        heading={`${solutions.title}`}
        post={solutions}
        bannerImageAlt={`${solutions.title} Banner Image`}
        bannerImageAlt2={`${solutions.title} Banner Image 2`}
        bannerImage={`${
          solutions.image
            ? solutions.image
            : "/site-assets/images/image-placeholder.webp"
        }`}
        bannerImage2={`${
          solutions.secondary_banner_image
            ? solutions.secondary_banner_image
            : "/site-assets/images/image-placeholder.webp"
        }`}
        dualBannerImage={true}
      />
      <SimpleTwoColumns
        global={global}
        customClass={`mb-5 text-center`}
        content1={solutions.intro}
        content2={``}
        // bottomBannerCTA={true}
        // buttomBannerCTALINK={`/jobs/internal/`}
        // buttomBannerCTATitle={`join gap personnel`}
      />

      <SimpleImageWithText
        global={global}
        customClass={` pb-5 mt-5 pt-4`}
        backgroundColor={solutions.jobs_available_list_hex_color_code}
        content1={
          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: solutions?.jobs_available_list }}
          />
        }
        imageAltText={`Gap Personnel Careers Benefits Image`}
        imageUrl={`${
          solutions.image_with_text
            ? solutions.image_with_text
            : "/site-assets/images/image-placeholder.webp"
        }`}
      />
      <SimpleTextWithText
        global={global}
        customClass={` mb-5 pb-5 pt-4`}
        logoImage={solutions.what_makes_it_different_logo}
        logoImageAlt={`${solutions.title} logo`}
        colorCodeContent1={solutions.sounds_like_a_color_hex_color_code}
        colorCodeContent2={solutions.what_makes_it_diffrent_hex_color_code}
        content1={
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: solutions?.sounds_like_a_good_fit,
            }}
          />
        }
        content2={
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: solutions?.what_makes_it_different,
            }}
          />
        }
      />

      {all_jobs.length >= 1 && (
        <LatestJobs
          global={global}
          pathPrefix={`homepage.latest_jobs`}
          customClass={`mt-3 mb-5`}
          bgColor={solutions.live_jobs_hex_color_code}
          colorCode={solutions.live_jobs_hex_color_code}
          buttoncolor={solutions.live_jobs_hex_color_code}
          buttonTitle={`view all jobs`}
          buttonLink={`/jobs/`}
          heading={`Find work that suits you`}
          subtitle={`jobseekers`}
          label={false}
          all_jobs={all_jobs}
        />
      )}  
      <SimpleForm form_id={solutions.form}/>

      <SimpleTwoColumns
        global={global}
        customClass={`mb-5 `}
        colorCode={solutions.get_in_touch_hex_color_code}
        content1={
          <div className="text-white text-decoration-none">
            <div className="w-100 d-inline-block mb-4">
              <h1>Get in touch</h1>
            </div>
            <div className="d-flex justify-content-between">
              <div className="d-flex-row p-2">
                {solutions.branch}
              </div>
              <div className="d-flex-row p-2">
                <div>
                  <p>
                    Tel:{" "}
                    <a
                      className="text-white text-decoration-none"
                      href={`tel:${solutions.contact_number}`}
                    >
                      {solutions.contact_number}
                    </a>
                  </p>
                </div>
                <div>
                  <p>
                    Email:{" "}
                    <a
                      className="text-white text-decoration-none"
                      href={`mailto:${solutions.company_email}`}
                    >
                      {solutions.company_email}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        }
        content2={""}
        // bottomBannerCTA={true}
        // buttomBannerCTALINK={`/jobs/internal/`}
        // buttomBannerCTATitle={`join gap personnel`}
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const solutions = (await Collection("solutions")).getJsonItem(
    params.url_slug,
    "url_slug"
  );

  const all_jobs = (await Jobs())
    .filter(function (job) {
      return (
        job.categories
          // Pulls client category
          .find((cat) => cat.id === "5eac1d7e-f98e-4892-a281-29a1b974bae6")
          ?.values?.map((cat) => cat.id)
          .includes(solutions.id)
      );
    })
    .filter(function (job) {
      return new Date(job?.expires_at) >= new Date();
    })
    .getItems()
    .slice(0, 8);

  return {
    props: {
      global,
      solutions,
      all_jobs,
    },
  };
}

export async function getStaticPaths() {
  const pagePath = (await Collection("solutions")).getPaths("url_slug");
  return {
    paths: pagePath,
    fallback: false,
  };
}
